import { render, staticRenderFns } from "./SupplierPurchaseOrder.vue?vue&type=template&id=2181bc4a&"
import script from "./SupplierPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./SupplierPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports